<template>
  <div class="card-inner">
    <h3 class="font-weight-bold">Galeria</h3>
    <viewer :images="images" class="images clearfix">
      <img v-for="src in images" :src="src.data" :key="src" class="image" :alt="src.title">
    </viewer>
  </div>
</template>
<script>
import 'viewerjs/dist/viewer.css'
// import Viewer from 'v-viewer'

export default {
  props: ['profilePicture', 'images'],
  data () {
    return {
    }
  },
  methods: {
  },
  mounted () {
  },
  watch: {
  }
}
</script>
<style lang="css">
  .image {
    height: 200px;
    cursor: pointer;
    margin: 5px;
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// src/components/partial/validations/ValidationImages.vue